import {
  MyTaskCardList,
  MyTaskPageHeader,
  MyTaskPagination,
  TaskStatusButtonGroup,
} from '@exam-management/my-task-list';
import { Flex, Text } from '@shared/components';

export default function HomePage() {
  return (
    <Flex
      sx={{
        minHeight: '100dvh',
        flexDirection: 'column',
      }}
    >
      <Text variant='h2' sx={(theme) => ({ p: theme.spacing(8, 6) })}>
        My Task
      </Text>
      <Flex
        sx={(theme) => ({
          p: theme.spacing(6),
          m: theme.spacing(6),
          flexDirection: 'column',
          gap: theme.spacing(4),
          flexGrow: 1,
          borderRadius: theme.shape.rounded(2),
          background: theme.palette.background.paper,
        })}
      >
        <TaskStatusButtonGroup />
        <Flex sx={(theme) => ({ gap: theme.spacing(4), flexDirection: 'column' })}>
          <MyTaskPageHeader />
          <MyTaskCardList />
          <MyTaskPagination />
        </Flex>
      </Flex>
    </Flex>
  );
}
